import React, { useState } from 'react';
import { useTranslate } from '../../../components/TranslationText';

export default function DecisionFilter({ submit }) {
    const { translate } = useTranslate();
    const [search, setSearch] = useState('');
    const [year, setYear] = useState('All Years');

    const handleSearch = () => {
        submit({ search, year });
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleSearch();
    };

    return (
        <div className="bg-white p-main border-15 mb-4 p-4">
            <div className="row g-3">
                <div className="col-lg-7 col-md-12">
                    <label className="form-label text-muted" style={{ fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>
                        {translate('web.searchDecisions', 'Search Decisions')}
                    </label>
                    <div className="input-group">
                        <span className="input-group-text bg-white border-end-0">
                            <i className="fa-solid fa-magnifying-glass text-muted"></i>
                        </span>
                        <input
                            type="text"
                            className="form-control border-start-0 ps-0"
                            placeholder={translate('web.searchPlaceholder', 'Search by horse name or show...')}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                </div>

                <div className="col-lg-3 col-md-6">
                    <label className="form-label text-muted" style={{ fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>
                        {translate('web.year', 'Year')}
                    </label>
                    <select
                        className="form-select"
                        value={year}
                        onChange={(e) => setYear(e.target.value)}
                    >
                        <option value="All Years">{translate('web.allYears', 'All Years')}</option>
                        <option value="2024">2024</option>
                        <option value="2023">2023</option>
                        <option value="2022">2022</option>
                    </select>
                </div>

                <div className="col-lg-2 col-md-4 d-flex align-items-end">
                    <button
                        className="btn btn-danger w-100"
                        style={{ fontWeight: '500' }}
                        onClick={handleSearch}
                    >
                        <i className="fa-solid fa-filter me-2"></i>
                        {translate('web.applyFilters', 'Apply Filters')}
                    </button>
                </div>
            </div>
        </div>
    );
}
